// #region Imports
import { defineComponent } from "vue";
import modalMixin from "../../mixins/modal.mixin";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-entity-popup',
    // #endregion
    // #region Mixins
    mixins: [modalMixin],
    // #endregion
    // #region Props
    props: {
        window: Object
    },
    // #endregion
    // #region Computes
    computed: {
        hasPortalFooter() {
            return this.$appHost.portalVue.hasForTarget('__footer_' + this.currentWindow.id);
        }
    }
    // #endregion
});
// #endregion
